module.exports = __webpack_public_path__ + "img/needs.f793b3f5.svg";